(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["loom-video"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('loom-embed')) {
    customElements.define('loom-embed', class extends HTMLElement {
      connectedCallback() {
        const poster = this.querySelector('.loom-embed__poster');
        if (!poster || !this.dataset.embed) return;
        poster.addEventListener('click', () => this.load(), { once: true });
      }
      load() {
        const iframe = document.createElement('iframe');
        iframe.src = this.dataset.embed;
        iframe.title = this.dataset.title || 'Loom video';
        iframe.className = 'loom-embed__iframe';
        iframe.allow = 'autoplay; fullscreen; picture-in-picture';
        iframe.setAttribute('allowfullscreen', '');
        this.replaceChildren(iframe);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
